<template>
    <div>
        <div class="d-flex justify-content-between">
            <div>
                <p class="mb-0">ในช่วง {{ fromDateForDisplay }} - {{ toDateForDisplay }}</p>
            </div>
            <div class="d-flex justify-content-center flex-nowrap">
                <b-form-datepicker
                    v-model="dateRanges.fromDate"
                    size="sm"
                    :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                    :date-disabled-fn="shouldFromDateDisabled"></b-form-datepicker>
                <div style="width: 40px" class="text-center">-</div>
                <b-form-datepicker
                    v-model="dateRanges.toDate"
                    size="sm"
                    :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                    :date-disabled-fn="shouldToDateDisabled"
                    dropleft></b-form-datepicker>
            </div>
        </div>

        <div class="mt-4">
            <div class="card">
                <div class="card-body">
                    <line-chart-lead-time :date-ranges="dateRanges" />
                </div>
            </div>
        </div>

        <div class="mt-4">
            <div class="row">
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <line-chart-top-product :date-ranges="dateRanges" />
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <LineChartLowProduct :date-ranges="dateRanges"/>
                        </div>
                    </div>
                </div>
            </div>
<!--            <div class="card">-->
<!--                <div class="card-body">-->
<!--                    <line-chart-total-so :date-ranges="dateRanges" />-->
<!--                </div>-->
<!--            </div>-->
        </div>

        <div class="row mt-4">
            <div class="col-12 col-md-6">
                <div class="mb-2">
                    <strong>10 อันดับสินค้าที่แลกมากที่สุด</strong>
                </div>
                <ReportLowProduct :date-ranges="dateRanges" />
            </div>
            <div class="col-12 col-md-6">
                <div class="mb-2">
                    <strong>10 อันดับสินค้าที่แลกน้อยที่สุด</strong>
                </div>
                <report-top-product :date-ranges="dateRanges" />
            </div>
        </div>


        <div class="mt-4">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <line-chart-top-customer :date-ranges="dateRanges" />
                        </div>
                    </div>
                </div>
            </div>
            <!--            <div class="card">-->
            <!--                <div class="card-body">-->
            <!--                    <line-chart-total-so :date-ranges="dateRanges" />-->
            <!--                </div>-->
            <!--            </div>-->
        </div>

        <div class="row mt-4">
            <div class="col-12 col-md-12">
                <div class="mb-2">
                    <strong>Top 10 ลูกค้าที่แลกมากที่สุด</strong>
                </div>
                <report-top-customer :date-ranges="dateRanges" class="mb-2" />
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import ReportTopCustomer from './ReportTopCustomer'
    import ReportTopProduct from "./ReportTopProduct";
    import ReportLowProduct from "./ReportLowProduct";
    import LineChartTotalSo from "./LineChartTotalSo";
    import LineChartTopCustomer from "./LineChartTopCustomer";
    import LineChartTopProduct from "./LineChartTopProduct";
    import LineChartLowProduct from "./LineChartLowProduct";
    import LineChartLeadTime from "./LineChartLeadTime";


    export default {
        components: {
            LineChartLeadTime,
            LineChartTopProduct,
            LineChartTopCustomer,
            LineChartTotalSo,
            ReportTopCustomer,
            ReportTopProduct,
            LineChartLowProduct,
            ReportLowProduct
        },

        data() {
            return {
                dateRanges: {
                    fromDate: moment().startOf('month').format('YYYY-MM-DD'),
                    toDate: moment().endOf('month').format('YYYY-MM-DD'),
                }
            }
        },

        computed: {
            fromDateForDisplay() {
                return moment(this.dateRanges.fromDate).format('D MMM YYYY')
            },

            toDateForDisplay() {
                return moment(this.dateRanges.toDate).format('D MMM YYYY')
            }
        },

        methods: {
            shouldFromDateDisabled(date) {
                if (this.dateRanges.toDate.length > 0) {
                    return moment(date).diff(moment(this.dateRanges.toDate)) > 0
                }

                return false;
            },

            shouldToDateDisabled(date) {
                if (this.dateRanges.fromDate.length > 0) {
                    return moment(date).diff(moment(this.dateRanges.fromDate)) < 0
                }

                return false
            }
        }
    }
</script>
